/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/car-manufacturing.png'

function ArmNode() {
  return (
    <div className="custom-node-generic robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={armLogo} alt="Arm Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Arm</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default ArmNode
